import * as React from "react";

const AccordionCtx = React.createContext(null);
const ItemCtx = React.createContext(null);

export default function Accordion({ children, type = 'single', collapsible = true, defaultValue = null }) {
  const [openValue, setOpenValue] = React.useState(defaultValue);
  const ctx = React.useMemo(() => ({ type, collapsible, openValue, setOpenValue }), [type, collapsible, openValue]);
  return (
    <AccordionCtx.Provider value={ctx}>
      <div className="w-full">
        {children}
      </div>
    </AccordionCtx.Provider>
  );
}

Accordion.Item = ({ value, children }) => {
  return (
    <ItemCtx.Provider value={{ value }}>
      <div className="border rounded">
        {children}
      </div>
    </ItemCtx.Provider>
  );
};

Accordion.Trigger = ({ children, className = '' }) => {
  const acc = React.useContext(AccordionCtx);
  const item = React.useContext(ItemCtx);
  const isOpen = acc?.openValue === item?.value;
  return (
    <button
      onClick={() => {
        if (!acc) return;
        if (acc.type === 'single') {
          if (isOpen && acc.collapsible) acc.setOpenValue(null);
          else acc.setOpenValue(item?.value);
        }
      }}
      className={`w-full text-left px-3 py-2 bg-muted/20 hover:bg-muted/30 ${className}`}
    >
      {children}
    </button>
  );
};

Accordion.Content = ({ children }) => {
  const acc = React.useContext(AccordionCtx);
  const item = React.useContext(ItemCtx);
  const isOpen = acc?.openValue === item?.value;
  if (!isOpen) return null;
  return (
    <div className="px-3 py-2">{children}</div>
  );
};